import { render } from "./MerchantDetailPage.vue?vue&type=template&id=2ff772aa&scoped=true&ts=true"
import script from "./MerchantDetailPage.vue?vue&type=script&lang=ts"
export * from "./MerchantDetailPage.vue?vue&type=script&lang=ts"

import "./MerchantDetailPage.vue?vue&type=style&index=0&id=2ff772aa&scoped=true&lang=css"

import exportComponent from "/home/runner/work/bakery-platform/bakery-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff772aa"]])

export default __exports__